import { Skeleton } from '@capsicum/common-web';

import * as S from './styles';

export const TransactionCardsSkeleton = () => {
	return (
		<S.SkeletonList>
			<Skeleton borderRadius={4}>
				<S.SkeletonHeaderRow inline />
				<S.SkeletonCardRow count={8} inline />
			</Skeleton>
		</S.SkeletonList>
	);
};
